import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights } from '../../themes/styles';

export interface IDashboardStyles {
  root: IStyle;
  header: IStyle;
  title: IStyle;
  controls: IStyle;
  body: IStyle;
  container: IStyle;
  widget: IStyle;
}

export interface IDashboardClassNames {
  root: string;
  header: string;
  title: string;
  controls: string;
  body: string;
  container: string;
  widget: string;
}

export const dashboardStylesDefault = (theme: IH2OTheme): Partial<IDashboardStyles> => ({
  root: {
    paddingTop: 30,
    '&.no-header': {
      paddingTop: 0,
    },
  },
  header: {
    display: 'flex',
    lineHeight: 32,
    marginBottom: 30,
  },
  title: {
    flex: 1,
    fontSize: FontSizes.xlarge,
    fontWeight: FontWeights.semiBold,
    color: theme.semanticColors?.textQuaternary,
  },
  controls: {
    display: 'flex',
    gap: 14,
  },
  body: {},
  container: {
    display: 'flex',
    gap: 24,
    marginBottom: 24,
    overflow: 'hidden',
    '&.vertical': {
      flexDirection: 'column',
    },
    ':last-child': {
      marginBottom: 0,
    },
    '&.one, &.oneOne, &.oneOneOne': {
      '> div': {
        flex: 1,
      },
    },
    '&.oneTwo': {
      '> div:nth-child(1)': {
        flex: 1,
      },
      '> div:nth-child(2)': {
        flex: 2,
      },
    },
    '&.twoOne': {
      '> div:nth-child(1)': {
        flex: 2,
      },
      '> div:nth-child(2)': {
        flex: 1,
      },
    },
    '&.oneThree': {
      '> div:nth-child(1)': {
        flex: 1,
      },
      '> div:nth-child(2)': {
        flex: 3,
      },
    },
    '&.threeOne': {
      '> div:nth-child(1)': {
        flex: 3,
      },
      '> div:nth-child(2)': {
        flex: 1,
      },
    },
  },
  widget: {
    height: '100%',
    overflow: 'hidden',
  },
});

export const dashboardStylesSmallGap: Partial<IDashboardStyles> = {
  container: {
    gap: 16,
    marginBottom: 16,
  },
};
